import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  chakra,
  Checkbox,
  HStack,
} from "@chakra-ui/react";
import React from "react";
import { HiMinus } from "react-icons/hi";
import {
  NotificationPreferenceCategory,
  NotificationPreferencesDto,
} from "../hooks";
import { NotificationPreferenceSubcategoryForm } from "./notification-preference-subcategory-form";

export interface NotificationPreferenceCategoryAccordionProps
  extends NotificationPreferenceCategory {
  handleChange: (
    category: keyof NotificationPreferencesDto,
    subcategory: string,
    event: React.ChangeEvent<HTMLInputElement>,
  ) => void;
  handleSelectAll: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
export const NotificationPreferenceCategoryAccordion: React.FC<
  NotificationPreferenceCategoryAccordionProps
> = (props) => {
  return (
    <AccordionItem>
      <AccordionButton>
        <HStack flex="1">
          <Checkbox
            name={props.id}
            size="lg"
            colorScheme="green"
            aria-label={"Subscribe to all " + props.title + " Notifications"}
            defaultChecked={props.allSelected}
            checked={props.allSelected}
            icon={<HiMinus />}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              props.handleSelectAll(e)
            }
          />
          <chakra.h6 apply="styles.widgetStyles.h6" flex="1" textAlign="left">
            {props.title}
          </chakra.h6>
        </HStack>
        <AccordionIcon />
      </AccordionButton>
      <AccordionPanel py={4}>
        {props.subcategories.map((subcategory, idx) => (
          <NotificationPreferenceSubcategoryForm
            key={subcategory.topic + idx}
            {...subcategory}
            category={props.id}
            handleChange={props.handleChange}
          />
        ))}
      </AccordionPanel>
    </AccordionItem>
  );
};
